import { useAuth0 } from "@auth0/auth0-react";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import SearchComp from "../../../../components/Searchcomponent";
import FinanceSettingService from "../../../../Lib/API/FinanceSetting/FinanceSetting";
import ComponentHeading from "../../componentHeading/ComponentHeading";
import SettingHeader from "../../SettingHeader/settingHEader";
import Tree from "../../Tree/Tree";

const ChargeTypesView = ({ heading }) => {
  const [typeID, setTypeID] = useState("High Holiday Fund");
  const [disable, setDisable] = useState(false);
  const [addNew, setAddNew] = useState(false);
  const [disableAddNew, setDaisableAddNew] = useState(false);
  const [edit, setEdit] = useState(false);
  const [chargeTypeTree, setChargeTypeTree] = useState(true);
  const [addPath, setAddPath] = useState();
  const [ledgerSubLedgerList, setLedgerSubLedgerList] = useState([]);
  const { getAccessTokenSilently } = useAuth0();

  const getTypeID = (name) => {
    setTypeID(name);
  };
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.includes("view")) {
      setEdit(false);
      setDaisableAddNew(false);
      setDisable(false);
    }
    fetchMyAPI();
  }, [pathname]);
  const formik = useFormik({
    initialValues: {},
  });
  const treeData = [
    {
      id: "1",
      label: "Donations",
      child: [
        {
          id: "child1",
          label: "Brooklyn General Operations",
        },
        {
          id: "child2",
          label: "Clergy",
        },
        {
          id: "child3",
          label: "High Holiday Fund",
        },
        {
          id: "child4",
          label: "Kiddush",
        },
        {
          id: "child5",
          label: "Nehma",
        },
      ],
    },
    { id: "2", label: "Memberships" },
    { id: "3", label: "Other" },
  ];
  const fetchMyAPI = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getLedgerSubLedgerList(token).then((res) =>
      setLedgerSubLedgerList(res?.ledgers)
    );
  };
  return (
    <div className="w-100">
      <SettingHeader
        heading={heading}
        edit={edit}
        addNew={addNew}
        path={"/charge-types/view"}
        setAddNew={setAddNew}
        parentHeading={"Financial"}
        alertOnEdit={edit}
      />
      <div className=" pb-5 search-input-types">
        <SearchComp
          value={""}
          setSearchText={""}
          placeholder="Search charge type"
        />
      </div>
      <div className="setting-main">
        <div className="left-menu-div">
          <Tree
            btnText={"Add Charge Type"}
            disableAddNew={disableAddNew}
            setAddNew={setAddNew}
            setDaisableAddNew={setDaisableAddNew}
            setDisable={setDisable}
            setEdit={setEdit}
            chargeTypeTree={true}
            treeData={ledgerSubLedgerList}
            formik={formik}
            getTypeID={getTypeID}
            addPath={addPath}
          />
        </div>
        <div className="settings-details">
          <ComponentHeading
            type={typeID}
            heading={heading}
            addNew={addNew}
            disable={disable}
            setDisable={setDisable}
            setDaisableAddNew={setDaisableAddNew}
            edit={edit}
            setEdit={setEdit}
            chargeTypeTree={chargeTypeTree}
            setAddPath={setAddPath}
          />
        </div>
      </div>
    </div>
  );
};

export default ChargeTypesView;
